import { FC } from 'react'

export type StepActionContentProps = {
  taskId: string
}

export type StepActionContentComponent = FC<StepActionContentProps>

export type ActionType = 'basic_task' | 'training'

export const parseConfigurationJson = (
  json: string | null | undefined
): Record<string, unknown> | null => {
  if (!json) return null

  try {
    const parsed: unknown = JSON.parse(json)

    if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
      const record: Record<string, unknown> = { ...parsed }
      return record
    }

    return null
  } catch {
    return null
  }
}
